import { z } from 'zod'

export const CreateEnrollmentSchema = z.object({
  courseId: z.string().uuid('Invalid course ID format'),
})

export const UpdateEnrollmentSchema = z.object({
  status: z.enum(['active', 'suspended', 'completed']).optional(),
})

export type CreateEnrollmentInput = z.infer<typeof CreateEnrollmentSchema>
export type UpdateEnrollmentInput = z.infer<typeof UpdateEnrollmentSchema>
